module.exports = __webpack_public_path__ + "img/video-preview.3415b78.png";